module.exports = __webpack_public_path__ + "img/optionD.8eb6db63.png";